module.exports = __webpack_public_path__ + "img/siberian-husky.55920001.svg";